/**
 * Which way the home panel's composer faces (kitecorp/transferify-ui#3140): sending files, or asking for
 * them. Apart from the rest of the request rules because the panel reads it on the landing every visitor
 * loads, and the request rules pull in the requests' own modules, which only request mode needs.
 */
export type ComposerMode = "send" | "request";

/**
 * Files dropped or picked while asking for files mean the person is sending after all, so the composer
 * turns back to sending, where those files are shown. Nothing else moves it.
 */
export function composerModeAfterFiles(mode: ComposerMode, previousCount: number, count: number): ComposerMode {
	return mode === "request" && count > previousCount ? "send" : mode;
}
